import { Fragment, useEffect, useRef, useState } from 'react';
import {
    Tooltip,
    tooltipClasses,
    TooltipProps,
    Typography
} from '@mui/material';
import styled from 'styled-components';

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} placement="bottom-end">
        {props.children}
    </Tooltip>
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        background: 'linear-gradient(180deg, #E952B5 0%, #D735B3 100%)',
        color: '#4F018A',
        maxWidth: 220,
        fontSize: '14px',
        fontWeight: '700',
        lineHeight: '1.5',
        zIndex: '5'
    }
}));

const TOOLTIP_TIMER = 3000;

export const CashmanTooltip = ({ children, content, classes = '' }: any) => {
    const [open, setOpen] = useState(false);
    const tooltipRef = useRef<HTMLDivElement>(null);

    const toggleTooltip = (e: React.MouseEvent) => {
        e.stopPropagation();
        setOpen((prevState) => !prevState);
    };

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (open) {
            timer = setTimeout(() => {
                setOpen(false);
            }, TOOLTIP_TIMER);
        }
        return () => clearTimeout(timer);
    }, [open]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                tooltipRef.current &&
                !tooltipRef.current.contains(event.target as Node)
            ) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);

    const formatTextWithNewlines = (text: string) => {
        return text.split('\n').map((line, index) => (
            <Fragment key={index}>
                {line}
                <br />
            </Fragment>
        ));
    };

    return (
        <HtmlTooltip
            title={
                <Fragment>
                    <Typography
                        color="white"
                        fontWeight={'700'}
                        style={{ textShadow: '0px 1px 1px #000' }}
                    >
                        DROP RATES
                    </Typography>
                    {formatTextWithNewlines(content)}
                </Fragment>
            }
            open={open}
            onClose={() => toggleTooltip}
            disableHoverListener
            disableFocusListener
            disableTouchListener
        >
            <div
                ref={tooltipRef}
                onClick={toggleTooltip}
                className={'html-tooltip ' + classes}
            >
                {children}
            </div>
        </HtmlTooltip>
    );
};
